import { useRef, useState, FC } from 'react';
import heic2any from 'heic2any';
import s from './FileUpload.module.css';

type FileUploadProps = {
    uploadDocument: (payload: { file: File }) => Promise<any>;
};

const FileUpload: FC<FileUploadProps> = ({ uploadDocument }) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const [isFileUploaded, setIsFileUploaded] = useState(false);

    const [isConvertingOrUploading, setIsConvertingOrUploading] = useState(false);

    const handleClick = () => {

        if (!isConvertingOrUploading) {
            fileInputRef.current?.click();
        }
    };

    const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        setIsConvertingOrUploading(true);

        try {

            if (file.type === 'image/heic' || file.type === 'image/heif') {
                const convertedBlobOrBlobs = await heic2any({
                    blob: file,
                    toType: 'image/jpeg',
                    quality: 0.9,
                });

                const blobParts = Array.isArray(convertedBlobOrBlobs)
                    ? convertedBlobOrBlobs
                    : [convertedBlobOrBlobs];

                const convertedFile = new File(
                    blobParts,
                    file.name.replace(/\.[^.]+$/, '.jpg'),
                    { type: 'image/jpeg' }
                );

                await uploadDocument({ file: convertedFile });
                setIsFileUploaded(true);
                console.log('Document uploaded successfully');
            } else {
                await uploadDocument({ file });
                setIsFileUploaded(true);
                console.log('Document uploaded successfully');
            }
        } catch (error) {
            setIsFileUploaded(false);
            console.error('Error converting/uploading file:', error);
        } finally {
            setIsConvertingOrUploading(false);
        }
    };

    return (
        <div
            className={`${s.upload_container} ${
                isConvertingOrUploading ? s.disabled_container : ''
            }`}
            onClick={handleClick}
        >
            {isConvertingOrUploading ? (

                <span className={s.upload_text}>
                 Uploading...
        </span>
            ) : isFileUploaded ? (
                <span className={s.upload_text}>Image Uploaded</span>
            ) : (
                <span className={s.upload_text}>
          Upload Image (.img, .jpg, .png, .heic)
        </span>
            )}
            <input
                type="file"
                ref={fileInputRef}
                className={s.file_input}
                onChange={handleFileUpload}
                disabled={isConvertingOrUploading}
            />
        </div>
    );
};

export default FileUpload;
